// To add a new layer
// 1. In LAYERS, add a slug
// 2. In helpers.layerDataToGeoJSON(), add a block that fetches data from the API and parses it into GeoJSON
// 3. In Map/index.js, in initializeMapLayer() add a block that prepares GeoJSON as a Leaflet layer

export const LAYERS = [
  'sensors',
  'bridges', 
];